module.exports = __webpack_public_path__ + "img/140.125d1818.png";